import { ImagesManager } from '../../misc/ImagesManager';
import { EventEmitter } from 'events';
export class _HeatmapLogoProvider {
    constructor() {
        this._eventEmitter = new EventEmitter();
        this.logoCache = {};
    }
    loadLogos(heatmapData) {
        if (!isValidArray(heatmapData)) {
            return;
        }
        const data = [...heatmapData];
        new Promise((resolve) => {
            for (let i = 0; i < data.length; i++) {
                const logoAddress = data[i].Instrument.LogoAddress;
                if (isValidString(logoAddress) && !this.isLogoExist(logoAddress)) {
                    ImagesManager.GetSvg(logoAddress)
                        .then((logo) => {
                        if (!isNullOrUndefined(logo)) {
                            const image = new Image();
                            image.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(logo);
                            image.onload = () => {
                                this.logoCache[logoAddress] = image;
                                this._eventEmitter.emit('load', data[i].Instrument);
                            };
                        }
                        else {
                            this.logoCache[logoAddress] = null;
                        }
                    })
                        .catch(() => {
                        this.logoCache[logoAddress] = null;
                    });
                }
            }
            resolve();
        })
            .then(() => {
            // Success
        })
            .catch(() => {
            // Error
        });
    }
    isLogoExist(logoAddress) {
        if (!isValidString(logoAddress)) {
            return false;
        }
        const logo = this.logoCache[logoAddress];
        return !isNullOrUndefined(logo);
    }
    getLogo(logoAddress) {
        if (!isValidString(logoAddress)) {
            return null;
        }
        return this.logoCache[logoAddress];
    }
    subscribeOnLoad(callback) {
        this._eventEmitter.on('load', callback);
    }
    unsubscribeOnLoad(callback) {
        this._eventEmitter.off('load', callback);
    }
}
export const HeatmapLogoProvider = new _HeatmapLogoProvider();
